import React, { useEffect, useState } from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";

import { Box, CircularProgress, Pagination } from "@mui/material";

import { BsThreeDotsVertical } from "react-icons/bs";

import { useNavigate } from "react-router-dom";
import MassMailViewdrawer from "./MassMailViewdrawer";
import { useDispatch, useSelector } from "react-redux";
import {
  convertArrayToString,
  formatDate,
  ShortenName,
} from "../../utils/const";
import { allLocation } from "../../redux/common/locationSlice";
import { padding } from "@mui/system";
// import
const columns = [
  {
    id: "job_id",
    label: "Job ID",
    minWidth: 50,
  },
  {
    id: "job_title",
    label: "Job Title",
    minWidth: 50,
  },

  {
    id: "location",
    label: "Location",
    minWidth: 50,
  },
  {
    id: "requirement_type",
    label: "Hiring Mode",
    minWidth: 50,
  },
  {
    id: "client_name",
    label: "Client",
    minWidth: 50,
  },
  {
    id: "total_email_sent_to_recruiter",
    label: "E-mail Deliver",
    minWidth: 50,
  },
  {
    id: "created_at",
    label: "Date",
    minWidth: 20,
  },
];

export default function CompanyListTable({
  historyData,
  pagination,
  page,
  handlePageChange,
}) {
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [hotListRow, setHotListRow] = useState({});
  const [show, setShow] = useState(false);
  const handleCloseShow = () => setShow(false);
  const handleShow = () => setShow(true);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const locations = useSelector((state) => state.location) || [];

  const massmailStatus = useSelector((state) => state.massmail.status);

  useEffect(() => {
    dispatch(allLocation());
  }, []);

  const getPreferLocationNames = (preferLocation) => {
    return preferLocation
      ?.map(
        (id) =>
          locations?.data?.locations?.find((location) => location.id === id)
            ?.name
      ) // Map IDs to names
      ?.filter(Boolean) // Remove any undefined values if IDs don't match
      ?.join(", "); // Join names with a comma and space
  };

  const handleOnClickViewDetails = (row) => {
    handleShow();
    setHotListRow(row);
  };

  const handleOnClickJobID = (column, row) => {
    if (column.id === "job_id") {
      handleShow();
      setHotListRow(row);
    }
  };

  return (
    <Box
      style={{
        backgroundColor: "#fff",
        margin: "10px 15px",
        padding: "0",
      }}
    >
      <Paper
        sx={{
          overflow: "hidden",
        }}
      >
        <TableContainer sx={{ maxHeight: 640 }}>
          <Table
            stickyHeader
            aria-label="sticky table"
            style={{ borderSpacing: "0 2px" }}
          >
            <TableHead>
              <TableRow>
                <TableCell
                  align="center"
                  style={{
                    minWidth: 50,
                    width: "20px",
                    backgroundColor: "#e5e7eb",
                    fontWeight: "600",
                    fontSize: "13px",
                    padding: "11px 14px 11px 1px",
                  }}
                >
                  <span>No.</span>
                </TableCell>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{
                      minWidth: column.minWidth,
                      backgroundColor: "#e5e7eb",
                      fontWeight: "600",
                      fontSize: "13px",
                      padding: "11px 14px 11px 1px",
                    }}
                  >
                    <span
                      style={
                        column.id === "slno"
                          ? {}
                          : {
                              borderLeft: "1.5px solid #ccc",
                              padding: "7px 1px 7px 10px",
                            }
                      }
                    >
                      {column.label}
                    </span>
                  </TableCell>
                ))}
                <TableCell
                  style={{
                    width: "20px",
                    backgroundColor: "#e5e7eb",
                    fontWeight: "600",
                    fontSize: "14px",
                    padding: "11px 14px 11px 1px",
                  }}
                ></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {massmailStatus === "loading" ? (
                <TableRow>
                  <TableCell colSpan={columns.length}>
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      py={4}
                    >
                      <CircularProgress color="info" />
                    </Box>
                  </TableCell>
                </TableRow>
              ) : (
                historyData?.length > 0 &&
                historyData.map((row, index) => {
                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      tabIndex={-1}
                      key={row.job_title}
                    >
                      <TableCell
                        align="center"
                        style={{
                          fontSize: "14px",
                          backgroundColor: "#f8f9fa",
                          padding: "10px 15px",
                          fontFamily: "Calibri",
                          color: "inherit",
                          cursor: "pointer",
                        }}
                      >
                        {index + 1}
                      </TableCell>

                      {columns.map((column) => {
                        const value = row[column.id];
                        return (
                          <TableCell
                            style={{
                              fontSize: "14px",
                              // fontWeight: 600,
                              // backgroundColor: '#DEEBF7',
                              backgroundColor: "#f8f9fa",
                              padding: "10px 15px",
                              fontFamily: "Calibri",
                              cursor: column.id === "job_id" ? "pointer" : "",
                              textDecoration:
                                column.id === "job_id" ? "underline" : "",
                              color:
                                column.id === "population"
                                  ? "#154e83"
                                  : column.id === "density"
                                  ? "#00B050"
                                  : column.id === "date"
                                  ? "#154e83"
                                  : "inherit",
                            }}
                            key={column.id}
                            align={column.align}
                            onClick={() => handleOnClickJobID(column, row)}
                          >
                            {column.format && typeof value === "number"
                              ? column.format(value)
                              : column.id === "created_at"
                              ? formatDate(value)
                              : column.id === "job_title"
                              ? ShortenName(value)
                              : column.id === "location"
                              ? getPreferLocationNames(value)
                              : column.id === "requirement_type"
                              ? convertArrayToString(value)
                              : column.id === "total_email_sent_to_recruiter"
                              ? value + row?.total_email_sent_to_candidate
                              : value}
                          </TableCell>
                        );
                      })}
                      <TableCell
                        style={{
                          fontSize: "14px",
                          // fontWeight: 600,
                          // backgroundColor: '#DEEBF7',
                          backgroundColor: "#f8f9fa",
                          padding: "10px 15px",
                          fontFamily: "Calibri",
                          color: "inherit",
                          cursor: "pointer",
                          // textAlign:'center',
                        }}
                      >
                        <Box
                          variant="contained"
                          size="large"
                          onClick={() => handleOnClickViewDetails(row)}
                        >
                          <BsThreeDotsVertical />
                        </Box>
                      </TableCell>
                    </TableRow>
                  );
                })
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <Box sx={{ float: "right", marginBottom: "10px" }}>
          <Pagination
            count={pagination.total_pages}
            page={page}
            onChange={handlePageChange}
            color="primary"
          />
        </Box>
        {/* <TablePagination
          rowsPerPageOptions={[5, 10, 25, 100]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        /> */}
      </Paper>

      <MassMailViewdrawer
        handleShow={handleShow}
        handleClose={handleCloseShow}
        show={show}
        jobdata={hotListRow}
      />
    </Box>
  );
}
